import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M30 10.002V12h-3a1 1 0 1 0 0 2h3v2h-3a1 1 0 1 0 0 2h3v2h-3a1 1 0 1 0 0 2h3c0 3.311-2.692 6-6 6-3.313 0-6-2.688-6-6.002V10.002A6.006 6.006 0 0 1 24 4c3.313 0 6 2.688 6 6.002M24 2c-4.413 0-8 3.585-8 8.002v11.996A8 8 0 0 0 24 30c4.413 0 8-3.585 8-8.002V10.002A8 8 0 0 0 24 2m13 19a1 1 0 0 0-1 1c0 6.628-5.372 12-12 12s-12-5.372-12-12a1 1 0 1 0-2 0c0 7.397 5.735 13.453 13 13.965V44h-4c-1.333 0-1.333 2 0 2h10c1.333 0 1.333-2 0-2h-4v-8.035c7.266-.513 13-6.569 13-13.965a1 1 0 0 0-1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgMicOnOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MicOnOutlined_default = SvgMicOnOutlined;

export { MicOnOutlined_default as default };
